module.exports = __webpack_public_path__ + "static/media/country-02.f1d964a8.png";